<div class="downloadCsv" [style.display]="showBtn">
    <button mat-button class="btn btn-outline-black btn-lg btn-block " (click)="downloadAllCsv()">
        {{'Download All Tables' | i18n}}
    </button>
</div>
<!-- <div>
    <tag-data [tableData]="tableData" [uid]="uid"></tag-data>
</div> -->

<div class="extrTable-contain" scope="row" *ngFor="let extTbl of tableData; let i = index">
    <div>
        <h3>{{'Table' | i18n}} {{i+1}}</h3>
    </div>
    <hr>
    <table class="table table-striped ">
        <tbody>
            <tr scope="row" *ngFor="let row of extTbl">
                <td scope="row" *ngFor="let cell of row; let i = index">
                    {{cell.text}}
                </td>
            </tr>
        </tbody>
    </table>
    <div class="downloadCsv">
        <button mat-button class="btn btn-outline-black btn-lg btn-block " (click)="downloadCsv(extTbl, i+1)">
            {{'Download Table' | i18n}} {{i+1}}
        </button>
    </div>
    <hr>

</div>
<div (click)="downloadImg()">
    {{uid}}
</div>